import { BadgeSize } from './Badge.types';

export const BADGE_SIZES = {
    [BadgeSize.SMALL]: { font: '70%', padding: '0 6px' },
    [BadgeSize.DEFAULT]: { font: '80%', padding: '2px 8px 0 8px' },
};
